const translations = {
    errorMessage: 'There was an error connecting your John Deere Account™. Please try again later.'
};

export default translations;
